import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoResourceUser, DtoResourceUser } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoResourceUserEntityDataService } from '../interfaces/dto.resource.user.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceUserEntityDataService extends EntityDataService<IDtoResourceUser> implements IDtoResourceUserEntityDataService {

    constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
        super(http, null, configService, loggingService);
    }

    public getForMandatorByResource$(mandator: string, resourceId: string): Observable<IDtoResourceUser[]> {
        return this.httpGet(`/api/web/resourceuser/mandator/${mandator}/resource/${resourceId}`)
            .pipe(map((entities: IDtoResourceUser[]) => {
                const result: IDtoResourceUser[] = [];
                if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
                    for (const entity of entities) {
                        result.push(this.createEntityFromJson(entity));
                    }
                }
                return result;
            }));
    }

    public async getForMandatorByResourceAsync(mandator: string, resourceId: string): Promise<IDtoResourceUser[]> {
        return (await this.getForMandatorByResource$(mandator, resourceId).toPromise());
    }

    protected override createEntityFromJson(json: any): IDtoResourceUser {
        const result: IDtoResourceUser = (UtilsJson.deserialize(json, DtoResourceUser) as IDtoResourceUser);
        if (result !== null) {
            result.setReferences();
        }

        return result;
    }

}
